define('OutSystems/ReactView/Root',["require", "exports", "tslib", "OutSystems/ClientRuntime/ApplicationInfo", "OutSystems/ClientRuntime/EventDispatcher", "OutSystems/ClientRuntime/Injector", "OutSystems/ClientRuntime/Injector/KnownServices", "OutSystems/ClientRuntime/Navigation", "OutSystems/ClientRuntime/Transitions", "prop-types", "react", "react-transition-group", "./convertCssTransitionClassNames", "./CSSHelper"], function (require, exports, tslib_1, ApplicationInfo, EventDispatcher_1, Injector, KnownServices_1, Navigation_1, Transitions_1, PropTypes, React, react_transition_group_1, convertCssTransitionClassNames_1, CSSHelper) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var DeviceClasses;
    (function (DeviceClasses) {
        var PhoneClass = "phone";
        var TabletClass = "tablet";
        var DesktopClass = "desktop";
        var PortraitClass = "portrait";
        var LandscapeClass = "landscape";
        var deviceClasses = [];
        function getViewportSize() {
            return {
                width: window.innerWidth || document.documentElement.clientWidth,
                height: window.innerHeight || document.documentElement.clientHeight,
            };
        }
        function defaultGetDeviceClasses() {
            var viewportSize = getViewportSize();
            var orientation;
            var device;
            if (viewportSize.width < 768) {
                device = PhoneClass;
            }
            else if (viewportSize.width <= 1024) {
                device = TabletClass;
            }
            else if (ApplicationInfo.isWebApplication()) {
                device = DesktopClass;
            }
            else {
                return [];
            }
            if (viewportSize.width > viewportSize.height) {
                orientation = LandscapeClass;
            }
            else {
                orientation = PortraitClass;
            }
            return [device, orientation];
        }
        var getDeviceClasses = Injector.resolve(KnownServices_1.ServiceNames.DeviceHelperClassProvider) || defaultGetDeviceClasses;
        Injector.addRegistrationListener(KnownServices_1.ServiceNames.DeviceHelperClassProvider, function (_, impl) {
            getDeviceClasses = impl || defaultGetDeviceClasses;
            if (impl) {
                setDeviceClasses();
            }
        });
        function clearDeviceClasses() {
            deviceClasses.forEach(function (cssClass) { return document.body.classList.remove(cssClass); });
        }
        DeviceClasses.clearDeviceClasses = clearDeviceClasses;
        function setDeviceClasses() {
            clearDeviceClasses();
            deviceClasses = getDeviceClasses();
            deviceClasses.forEach(function (cssClass) { return document.body.classList.add(cssClass); });
        }
        DeviceClasses.setDeviceClasses = setDeviceClasses;
    })(DeviceClasses || (DeviceClasses = {}));
    var NOWHERE_LOCATION_KEY = "nowhere-location-key";
    var Root = (function (_super) {
        tslib_1.__extends(Root, _super);
        function Root(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.hasScreenRendered = false;
            _this.state = {
                transition: new Transitions_1.Transition(""),
                animate: false,
                firstRender: true,
            };
            return _this;
        }
        Root.onBeforeNavigation = function (runtime, nextLocation, isBackNavigation) {
            if (runtime.onBeforeNavigation(nextLocation, isBackNavigation)) {
                CSSHelper.setIgnoreLoadErrors(true);
                return true;
            }
            return false;
        };
        Root.onAfterNavigation = function (runtime) {
            CSSHelper.setIgnoreLoadErrors(false);
            runtime.onAfterNavigation();
        };
        Root.getPreviousTransition = function (previousLocation) {
            return previousLocation && previousLocation.state && previousLocation.state.transition
                ? Transitions_1.sanitizeTransition(previousLocation.state.transition)
                : new Transitions_1.Transition("");
        };
        Root.getTransition = function (action, location, previousLocation) {
            if (Root.transitionOverride) {
                return Transitions_1.sanitizeTransition(Root.transitionOverride);
            }
            if (Navigation_1.locationReachedFromHistory(tslib_1.__assign({ action: action }, location))) {
                return Transitions_1.reverseTransition(Root.getPreviousTransition(previousLocation));
            }
            if (!location.state || !location.state.transition) {
                return new Transitions_1.Transition("");
            }
            return Transitions_1.sanitizeTransition(location.state.transition);
        };
        Root.prototype.getChildContext = function () {
            var _this = this;
            return {
                hasScreenRendered: function () { return _this.hasScreenRendered; },
            };
        };
        Root.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
            var transition = Root.getTransition(nextProps.history.action, nextProps.location, this.props.location);
            if (this.props.location !== nextProps.location) {
                this.setState(function () {
                    return { transition: transition, animate: !!transition.name, firstRender: false };
                });
            }
        };
        Root.prototype.UNSAFE_componentWillMount = function () {
            var _this = this;
            DeviceClasses.setDeviceClasses();
            var supportsOrientationChange = "onorientationchange" in window;
            var orientationEvent = supportsOrientationChange ? "orientationchange" : "resize";
            var handleOrientationChanges = function () { return _this.handleOrientationChanges(); };
            window.addEventListener(orientationEvent, handleOrientationChanges, false);
            this.handleDispose = function () {
                window.removeEventListener(orientationEvent, handleOrientationChanges);
            };
        };
        Root.prototype.componentDidMount = function () {
            if (!this.state.animate) {
                this.onTransitionStarted();
            }
            Root.transitionOverride = null;
            Root.onAfterNavigation(this.props.runtime);
        };
        Root.prototype.componentDidUpdate = function () {
            var runtime = this.props.runtime;
            this.onTransitionStarted();
            Root.transitionOverride = null;
            Root.onAfterNavigation(runtime);
        };
        Root.prototype.UNSAFE_componentWillUpdate = function () {
            this.hasScreenRendered = false;
        };
        Root.prototype.componentWillUnmount = function () {
            if (this.handleDispose) {
                this.handleDispose();
            }
        };
        Root.prototype.handleOrientationChanges = function () {
            setTimeout(function () {
                DeviceClasses.setDeviceClasses();
            }, 300);
        };
        Root.prototype.onTransitionStarted = function () {
            this.hasScreenRendered = true;
            setTimeout(function () {
                EventDispatcher_1.EventDispatcher.dispatch({ type: EventDispatcher_1.EventType.TransitionStart });
            });
        };
        Root.prototype.onTransitionEnded = function () {
            setTimeout(function () {
                EventDispatcher_1.EventDispatcher.dispatch({ type: EventDispatcher_1.EventType.TransitionEnd, args: EventDispatcher_1.TransitionEndResult.Success });
            });
        };
        Root.prototype.render = function () {
            var _this = this;
            var _a = this.props, children = _a.children, location = _a.location, history = _a.history, screenLoader = _a.screenLoader;
            var _b = this.state, transition = _b.transition, firstRender = _b.firstRender, animate = _b.animate;
            var transitionClassNames = convertCssTransitionClassNames_1.default(transition.name);
            if (firstRender) {
                var screenLoadPromise = screenLoader.load(location, history.action, history);
                if (screenLoadPromise) {
                    screenLoadPromise
                        .then(function () {
                        return _this.setState(function () {
                            return { firstRender: false };
                        });
                    })
                        .catch(function () { });
                }
                return null;
            }
            else {
                return (React.createElement(react_transition_group_1.TransitionGroup, { component: "div", id: "transitionContainer", childFactory: function (child) {
                        return React.cloneElement(child, {
                            classNames: transitionClassNames,
                            timeout: animate ? 300 : 0,
                        });
                    } },
                    React.createElement(react_transition_group_1.CSSTransition, { key: location.key, classNames: transitionClassNames, timeout: animate ? 300 : 0, onEnter: function () { return _this.onTransitionStarted(); }, onExited: function () { return _this.onTransitionEnded(); } },
                        React.createElement(React.Fragment, null, children))));
            }
        };
        Root.childContextTypes = {
            hasScreenRendered: PropTypes.func,
        };
        return Root;
    }(React.Component));
    exports.default = Root;
});
//# sourceMappingURL=Root.js.map;
